import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { PlayerForm } from "../components/PlayerForm";
import { Sheet } from "../components/ui";
import { en as t } from "../i18n/en";
import { api } from "../lib/api";
import { saveSeat } from "../lib/identity";

const CODE = /^[ABCDEFGHJKMNPQRTUVWXYZ234679]{5}$/;

export function Home() {
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [hosting, setHosting] = useState(false);
  const [howTo, setHowTo] = useState(false);

  function join(e: FormEvent) {
    e.preventDefault();
    const c = code.trim().toUpperCase();
    if (!CODE.test(c)) return setError(t.codeInvalid);
    navigate(`/r/${c}`);
  }

  async function host(nickname: string, color: string) {
    const seat = await api.createRoom(nickname, color);
    saveSeat({ roomCode: seat.roomCode, playerId: seat.playerId, playerToken: seat.playerToken, nickname });
    navigate(`/r/${seat.roomCode}`);
  }

  return (
    <main className="screen home">
      <header className="home-head">
        <h1 className="wordmark">
          Desi<span>Psych</span>
        </h1>
        <p className="lede">{t.tagline}</p>
      </header>

      <section className="sample-card" aria-label="Example question">
        <p className="deck-name">Desi Dictionary</p>
        <p className="prompt">The English word ‘shampoo’ comes from a Hindi word meaning ___.</p>
        <ul className="chips">
          <li>to wash hair</li>
          <li className="truth">to press or knead</li>
          <li>sweet foam</li>
        </ul>
        <p className="hint">One is real. The rest are your friends’ bluffs.</p>
      </section>

      <div className="actions">
        <button type="button" className="btn-primary" onClick={() => setHosting(true)}>
          {t.host}
        </button>
        <p className="divider"><span>{t.orJoin}</span></p>
        <form className="join" onSubmit={join} noValidate>
          <label htmlFor="code">{t.roomCode}</label>
          <div className="join-row">
            <input
              id="code"
              value={code}
              onChange={(e) => { setCode(e.target.value); setError(""); }}
              placeholder="e.g. KX7QP"
              maxLength={5}
              autoCapitalize="characters"
              autoComplete="off"
              aria-invalid={!!error}
              aria-describedby={error ? "code-error" : undefined}
            />
            <button type="submit" className="btn-outline">{t.join}</button>
          </div>
          {error && <p id="code-error" className="error">{error}</p>}
        </form>
      </div>

      <footer className="home-foot">
        <span>{t.footer}</span>
        <button type="button" className="link" onClick={() => setHowTo(true)}>{t.howToPlay}</button>
      </footer>

      {hosting && (
        <Sheet title={t.host} onClose={() => setHosting(false)}>
          <PlayerForm submitLabel={t.createRoom} onSubmit={host} />
        </Sheet>
      )}
      {howTo && (
        <Sheet title={t.howToPlay} onClose={() => setHowTo(false)}>
          <ol className="how-steps">
            {t.howSteps.map((s) => <li key={s}>{s}</li>)}
          </ol>
          <button type="button" className="btn-outline wide" onClick={() => setHowTo(false)}>{t.back}</button>
        </Sheet>
      )}
    </main>
  );
}
